// Copyright (c) 2022 by Move Closer

import { MappingConfig } from '@movecloser/front-core'

import { AbstractTypeDriver, RelatedType } from '../../shared'
import { ContentData, DescriptionOfContent } from '../contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class SnippetDriver extends AbstractTypeDriver<DescriptionOfContent, ContentData> {
  protected adapterMap: MappingConfig = {}
  protected dependencies: RelatedType[] = []
  protected key: RelatedType = SnippetRelatedType
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const SnippetRelatedType: RelatedType = 'snippet'
